import { useCallback, useEffect, useState } from "react";
import Icon from "../Icon";
import { NotionLogo } from "../widgets/NotionOrigen";
import * as api from "../../api";

// «Ver hechas»: las ultimas 50 tareas que la persona marco como hechas, cada una con
// «Recuperar». Es la red de seguridad de un ✓ pulsado sin querer cuando ya paso el aviso
// de «Deshacer». El servidor reabre el paso en el proyecto si la persona puede editarlo.
const cuando = iso => {
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const min = Math.round((Date.now() - d.getTime()) / 60000);
  if (min < 1) return "hace un momento";
  if (min < 60) return `hace ${min} min`;
  if (min < 24 * 60) return `hace ${Math.round(min / 60)} h`;
  return d.toLocaleDateString("es-ES", { day: "numeric", month: "short" });
};

export default function HechasPanel({ onRecuperar, onCerrar }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(false);

  const cargar = useCallback(async () => {
    try {
      const d = await api.getMisTareasHechas();
      setItems(Array.isArray(d?.items) ? d.items : []);
      setError(false);
    } catch { setError(true); }
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const recuperar = async t => { if (await onRecuperar(t)) cargar(); };

  return (
    <section className="mt-hechas-panel" aria-label="Tareas hechas">
      <div className="mt-hp-cab">
        <b>Hechas y descartadas recientes</b>
        <button type="button" className="mt-hp-cerrar" onClick={onCerrar}>Cerrar</button>
      </div>
      {error ? (
        <div className="mt-vacio-grupo" role="alert">No se han podido cargar.
          <button type="button" className="mt-hp-cerrar" onClick={cargar}>Reintentar</button></div>
      ) : items === null ? (
        <div className="mt-vacio-grupo" role="status">Cargando…</div>
      ) : !items.length ? (
        <div className="mt-vacio-grupo">Aún no has marcado ninguna como hecha ni descartada.</div>
      ) : items.map(t => (
        <div className="mt-hp-fila" key={t.id}>
          <span className="mt-hp-origen" title={t.origen === "notion" ? "Página de Notion" : "Paso de proyecto"}>
            {t.origen === "notion" ? <NotionLogo title="Página de Notion" /> : <Icon name="diagram-3" size={11} color="currentColor" />}
          </span>
          <span className="mt-hp-tit">{t.titulo}
            <small>{t.estado === "descartada" ? "Descartada · " : ""}{t.proyecto?.nombre ? `${t.proyecto.nombre} · ` : ""}{cuando(t.hecha_en)}</small>
          </span>
          <button type="button" className="mt-hp-rec" onClick={() => recuperar(t)}
            aria-label={`Recuperar: ${t.titulo}`}>Recuperar</button>
        </div>
      ))}
    </section>
  );
}
